import axios from 'axios';
import { apiUrl } from './ApiHost';
import authHeader from './AuthHeader';

class PlanService {
  getPlans() {
    return axios.get(apiUrl + 'plans', { headers: authHeader() });
  }

  getPlan(id) {
    return axios.get(apiUrl + 'plans/' + id, { headers: authHeader() });
  }

  getLastByClientId(id) {
    return axios.get(apiUrl + 'plans/client/' + id + "/last", { headers: authHeader() });
  }

  getPlanByClientId(id) {
    return axios.get(apiUrl + 'plans/client/' + id, { headers: authHeader() });
  }

  addPlan(plan) {
    return axios.post(apiUrl + 'plans', plan, { headers: authHeader() });
  }

  downloadPdf(plan) {
    return axios.post(apiUrl + 'plans/pdf', plan, { headers: authHeader(), responseType: 'blob' });
  }

  previewPlan(plan) {
    return axios.post(apiUrl + 'plans/preview', plan, { headers: authHeader() });
  }

  sendPlan(plan) {
    return axios.post(apiUrl + 'plans/send', plan, { headers: authHeader() });
  }

  updatePlan(plan) {
    return axios.put(apiUrl + 'plans', plan, { headers: authHeader() });
  }

  deletePlan(id) {
    return axios.delete(apiUrl + 'plans/' + id, { headers: authHeader() });
  }
}

export default new PlanService();